import type { Entry, UnresolvedLink } from 'contentful';
import type { LinkedIconProps } from 'libs/contentful/types';
import type { LinkedIconSkeleton } from './types';

export function toLinkedIcon(
  icon: Entry<LinkedIconSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'> | UnresolvedLink<'Entry'> | undefined,
): LinkedIconProps | undefined {
  if (icon == null || !('fields' in icon)) return undefined;

  const { fields, sys } = icon;

  return {
    sys: { id: sys.id },
    iconName: fields.iconName,
    label: fields.label,
    url: fields.url,
    showLabel: fields.showLabel,
    labelPlacement: fields.labelPlacement,
  };
}
